namespace UserInfo {
  export enum API {
    'login' = '/fast-escrow/usercenter/bff/generate_user_login_token',
    'get_user_info' = '/fast-escrow/usercenter/bff/get_init_user_info_for_credit',
    'get_dr_status' = '/fast-escrow/order/get_dr_status',
    'get_migrate_status' = '/fast-escrow/migration/query_user_to_migrate_status',
    // QueryUserCacheStatus：查询是否 Cache 用户(core) + 是否需要弹窗签新合约(uc)。
    // 路径已对齐后端网关(FastEscrow通用中间件，/user/sec 前缀)
    'query_user_cache_status' = '/user/sec/fast-escrow/transaction/query_user_cache_status',
    // UpdateCachePopupStatus(BFF 6.15)：上报签合同弹窗已展示，供后端控制频率(每月一次)。
    // 网关路径按 cache 接口约定推断(/user/sec 前缀)，待后端确认
    'update_cache_popup_status' = '/user/sec/fast-escrow/transaction/update_cache_popup_status',
    // QueryUserToggleStatus：查询 FES 开关状态(0:CREATED/1:DISABLED/2:ENABLED)。
    // 路径已对齐后端网关(FastEscrow通用中间件，/user/sec 前缀)
    'query_user_toggle_status' = '/user/sec/fast-escrow/transaction/query_user_toggle_status',
    'insight_fe_chat' = '/credit/insight/fe_chat', // 监控接口, 打到网关
  }
}

export default UserInfo;
